import React, { useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCartItemCount } from '../store/slices/cartSlice';
import { selectIsAuthenticated } from '../store/slices/authSlice';
import { createMobileNavItems } from '../utils/mobileNavConfig';

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const cartCount = useSelector(selectCartItemCount);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const mobileNavItems = useMemo(
    () => createMobileNavItems({ cartCount, isAuthenticated }),
    [cartCount, isAuthenticated]
  );

  const handleClick = (item) => {
    if (!item?.href) return;
    if (location.pathname === item.href) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    // When entering Auto Glass Finder from bottom nav, clear any persisted
    // filter state so the page starts fresh rather than restoring old selections.
    if (item.href === '/mobile/parts-finder') {
      try {
        sessionStorage.removeItem('partsFinderState');
        sessionStorage.removeItem('partsFinderRestore');
      } catch (_) {}
    }
    navigate(item.href);
  };

  const isActive = (item) => {
    if (item.href === '/mobile') {
      return location.pathname === '/mobile' || location.pathname === '/mobile/';
    }
    return location.pathname.startsWith(item.href);
  };

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[70] border-t border-slate-200 bg-white/95 shadow-[0_-6px_24px_rgba(15,23,42,0.08)] backdrop-blur-md pointer-events-auto"
      style={{ transform: 'translateZ(0)', WebkitTransform: 'translateZ(0)' }}
    >
      <nav className="grid grid-cols-6 text-[11px] font-medium text-slate-500">
        {mobileNavItems.map((item) => (
          <button
            key={item.id}
            type="button"
            onClick={() => handleClick(item)}
            aria-current={isActive(item) ? 'page' : undefined}
            className={`flex flex-col items-center justify-center gap-1 py-3 transition duration-150 ${
              isActive(item)
                ? 'text-slate-900 font-semibold'
                : 'text-slate-500 hover:text-slate-800'
            }`}
          >
            <item.icon
              className={`w-5 h-5 transition-colors ${
                isActive(item) ? 'text-primary-600 drop-shadow-sm' : 'text-slate-400'
              }`}
            />
            <span>{item.label}</span>
            {isActive(item) && (
              <span className="h-1.5 w-6 rounded-full bg-primary-500/90"></span>
            )}
            {item.badge ? (
              <span className="text-[10px] font-bold text-white bg-emerald-500 rounded-full px-2">
                {Math.min(item.badge, 99)}
              </span>
            ) : null}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default MobileBottomNav;
